"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
exports.Footer = function (props) {
    var className = props.className, children = props.children;
    var footerClasses = [
        vdl_prefix_1.vdlPrefix('footer')
    ];
    return React.createElement("footer", { className: classnames_1.classNames(className, footerClasses) }, children);
};
exports.Footer.propTypes = {
    className: PropTypes.string
};
exports.Footer.displayName = 'Footer';
